<script>
import axios from "axios";
import moment from "moment";

export default {
  props: {
    open: {
      type: Boolean,
      required: false,
      default: false,
    },
    dispatch: {
      type: Object,
      required: false,
    },
  },
  emits: ["close-modal", "refetch"],
  data() {
    return {
      dusType: undefined,

      agentIsValid: undefined,
      agentIsPending: undefined,
      agentIsError: undefined,

      fetchIsPending: undefined,
      fetchIsSuccess: undefined,
      fetchIsError: undefined,
    };
  },
  methods: {
    async checkAgent() {
      try {
        const { data } = await axios.get(
          `/api/admin/check-agent/${this.dispatch?.id}`
        ); 
        return data?.isValid;
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "¡Error!",
          text: "Su solicitud no pudo ser realizada.",
        });
      }
    },
    async fetchDUS() {
      this.agentIsPending = true;

      let isValid = await this.checkAgent();

      if (!isValid) {
        this.fetchIsPending = false;
        this.agentIsPending = false;
        this.agentIsValid = false;
        this.fetchIsError = true;

        this.$emit("close-modal"),
          this.$swal({
            icon: "error",
            title: "¡Error!",
            text: `El administrador no ha configurado las credenciales de comext.aduanas.cl para el agente ${this.dispatch?.agente?.nombre}.`,
          });

        return;
      }

      this.agentIsPending = false;
      this.agentIsValid = true;

      this.fetchIsPending = true;

      try {
        const query = {
          responseType: "blob",
          params: {
            dusType: this.dusType,
          },
        };

        const { data, headers } = await axios.get(
          `/api/admin/fetch-dus/${this.dispatch?.id}`,
          query
        );

        if (data) {
          if (headers["content-type"] == "application/json") {
            const text = await data.text();
            const json = JSON.parse(text);

            if (json.errors && json.errors.length > 0) {
              this.$emit("close-modal");
              this.$swal({
                icon: "error",
                title: "¡Error!",
                text: json.errors.join("\n"),
              });
              return;
            }
          }

          const href = URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute(
            "download",
            "DUS" +
              "-" +
              this.dispatch?.codigo +
              "-" +
              moment(new Date()).format("DD-MM-YYYY") +
              ".pdf"
          );

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        }

        this.fetchIsSuccess = true;

        this.$emit("close-modal");
        this.$emit("refetch");
          
        this.fetchIsSuccess = true;
        this.fetchIsError = false;
      } catch (err) {
        this.$emit("close-modal");

        const text = await err?.response?.data.text();
        const json = JSON.parse(text);

        if (json.errors && json.errors.length > 0) {
          this.$emit("close-modal");
          this.$swal({
            icon: "error",
            title: "¡Error!",
            text: json.errors.join("\n"),
          });
          return;
        }
      }

      this.fetchIsPending = false;
    },
  },
  watch: {
    open: async function (newVal) {
      if (newVal) {
        this.dusType = undefined;
        this.agentIsValid = undefined;
        this.agentIsError = undefined;
        this.agentIsPending = undefined;
        this.fetchIsSuccess = undefined;
        this.fetchIsPending = undefined;
        this.fetchIsError = undefined;
        //await this.checkAgent();
      }
    },
  },
  mounted() {},
};
</script>

<template>
  <div>
    <b-modal
      :visible="open"
      centered
      :hide-header="agentIsPending || fetchIsPending"
      :hide-footer="agentIsPending || fetchIsPending"
    >
      <template v-slot:modal-header> Buscar documento por DUS </template>

      <div
        v-if="agentIsPending || fetchIsPending"
        class="flex flex-row h-48 items-center gap-4 justify-center"
      >
        <b-spinner class="text-primary" style="width: 3em; height: 3em" />
      </div>

      <div
        v-if="!agentIsPending && !fetchIsPending"
        class="grid grid-cols-4 gap-4"
      >
        <div class="col-span-4 flex flex-col gap-2">
          <label>Tipo de envio</label>
          <select v-model="dusType">
            <option value="1">Primer envío</option>
            <option value="2">Segundo envío</option>
          </select>
        </div>
      </div>

      <template v-slot:modal-footer>
        <div></div>

        <div
          v-if="!agentIsPending && !fetchIsPending"
          class="flex flex-row gap-4 items-center justify-end"
        >
          <button class="btn-secundario" @click="$emit('close-modal')">
            Cancelar
          </button>
          <button
            class="btn-principal"
            :disabled="!dusType"
            @click="() => fetchDUS()"
          >
            Descargar
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
